import { Component } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-copy-offline-customer-key-dialog',
  templateUrl: './copy-offline-customer-key-dialog.component.html',
  styleUrls: ['./copy-offline-customer-key-dialog.component.scss'],
})
export class CopyOfflineCustomerKeyDialogComponent {
  readonly customerName: string;
  readonly customerId: string;
  readonly offlineCustomerKey: string;

  copied: boolean = false;

  constructor({ data }: DynamicDialogConfig) {
    this.customerName = data.customerName;
    this.offlineCustomerKey = data.offlineCustomerKey;
    this.customerId = data.customerId;
  }

  onCopy(): void {
    if (this.copied) return;
    this.copied = true;
    navigator.clipboard.writeText(this.offlineCustomerKey);
    setTimeout(() => (this.copied = false), 5000);
  }

  downloadKeyFile(): void {
    const blob = new Blob([this.offlineCustomerKey], { type: 'text/plain;charset=utf-8' });
    saveAs(blob, this.customerId);
  }
}
